import React from 'react';
import cssClasses from './TransactionsMenu.css';

const TransactionStats = ({ transactionStats, filename }) => (
    <React.Fragment>
        <div className={[cssClasses.statsContainer, cssClasses.contentBetween].join(' ')}>
            <div>
                {filename && <span className={[cssClasses.label, cssClasses.labelFilename, cssClasses.labelSpacing].join(' ')}>File: {filename}</span>}
            </div>
            <div>
                <span className={[cssClasses.label, cssClasses.labelWarning, cssClasses.labelSpacing].join(' ')}>Uncoded: {transactionStats.uncoded}</span>
                <span className={[cssClasses.label, cssClasses.labelPrimary, cssClasses.labelSpacing].join(' ')}>Total: {transactionStats.transactions}</span>
            </div>
        </div>
    </React.Fragment>
)

export default TransactionStats;


// WEBPACK FOOTER //
// ./src/components/TransactionsMenu/TransactionStats.js